export const AUDIT_RESOURCE_STORE = 'AUDIT_RESOURCE_STORE';
export const AUDIT_RESOURCE_UPDATE = 'AUDIT_RESOURCE_UPDATE';
export const AUDIT_RESOURCE_DESTROY = 'AUDIT_RESOURCE_DESTROY';
